import axios from 'axios'

const addresses = {
  /**
   * The Delete Shipping Address service deletes a shipping address from an identified SRC Profile or from a transaction.
   *
   * @param {String} addressId
   * @returns {Promise<Object>}
   */
  deleteShippingAddress(addressId) {
    return axios.delete(`/api/addresses/${addressId}`)
  }
}

export default addresses
